import { hasInheritAccess } from './isSharedHelper';
import type { StorageUnit } from 'store/storageunits/types';
import { ROOT, StorageUnitType } from 'store/storageunits/types';

type FolderLike = StorageUnit | typeof ROOT | undefined;

export const canModifyFolder = (
  unit: FolderLike,
  directAccess = false,
): boolean => {
  if (directAccess) {
    return true;
  }

  if (!unit) {
    return false;
  }

  if (unit.id === ROOT.id) {
    return true;
  }

  if ('type' in unit && unit.type !== StorageUnitType.Folder) {
    return false;
  }

  if ('access' in unit) {
    return hasInheritAccess(unit.access);
  }

  return false;
};

export const isReadOnlyFolder = (
  unit: FolderLike,
  directAccess = false,
): boolean => !canModifyFolder(unit, directAccess);

export const canModifyCurrentLocation = (
  parentId: string | undefined,
  directAccess: boolean,
  folderPath: StorageUnit[],
): boolean => {
  if (!parentId || parentId === ROOT.id) {
    return true;
  }

  const currentFolder =
    folderPath.length > 0 ? folderPath[folderPath.length - 1] : undefined;

  return canModifyFolder(currentFolder, directAccess);
};
